export function formatToCurrency(
  value: number | undefined,
  options?: Intl.NumberFormatOptions | undefined
) {
  const {
    style = "currency",
    currency = "USD",
    maximumFractionDigits = 2,
    minimumFractionDigits = 2,
  } = options || {};
  if (value == null) {
    return "-";
  }
  return value.toLocaleString("en-US", {
    style,
    currency,
    maximumFractionDigits,
    minimumFractionDigits,
  });
}

export function getFirstNameAndLastName(fullName: string | null) {
  if (!fullName) {
    return {
      firstName: "",
      lastName: "",
    };
  }

  const nameParts = fullName.split(" ").filter((part) => part.trim() !== "");

  const firstName = nameParts[0] || "";
  const lastName = nameParts.slice(1).join(" ") || "";

  return {
    firstName,
    lastName,
  };
}

export const removeTrailingSlash = (url: string) => url.replace(/\/$/, "");
